import type { PaymentFeesTranslations } from "../interfaces/paymentFees";

export const paymentFeesTranslations: PaymentFeesTranslations = {
  // Página
  page_title: "Tarifas y comisiones",
  page_subtitle:
    "Cuánto le cobramos a cada organización por mover dinero y cuánto nos cobra el proveedor, corredor por corredor.",
  refresh_button: "Actualizar",
  refresh_aria: "Recargar tarifas y comisiones",
  button_new_fee: "Regla avanzada",

  // Guía
  guide_title: "¿Cómo funcionan los precios?",
  guide_commission_title: "Comisión Coloca y costo del proveedor",
  guide_commission_body:
    "La comisión es lo que le cobramos a la organización en cada operación: es nuestro ingreso. El costo del proveedor es lo que el proveedor de pagos le cobra a Coloca. Un corredor necesita las dos para funcionar.",
  guide_scope_title: "Precio general y precio especial",
  guide_scope_body:
    "El precio general aplica a todas las organizaciones. Si una organización tiene precio especial en un corredor, ese reemplaza al general solo para ella. Para ver o cambiar los precios de una organización, elígela arriba.",
  guide_ranges_title: "Precio por rango de monto",
  guide_ranges_body:
    "Un precio puede cambiar según el monto de cada operación: por ejemplo, menos de 1.000.000 COP paga 1 % y desde 1.000.000 paga 0,5 %. Cada operación se mira por separado; no es el volumen acumulado del mes. El porcentaje del rango se cobra sobre todo el monto, no por partes.",
  guide_limits_title: "Mínimo y máximo",
  guide_limits_body:
    "La comisión nunca baja del mínimo ni sube del máximo, sin importar en qué rango caiga la operación.",
  guide_changes_title: "Cambios e historial",
  guide_changes_body:
    "Un precio nunca se sobrescribe: cada cambio queda como una versión nueva con fecha, autor y motivo, y se puede programar para más adelante. Cada cambio también llega al canal de Discord del equipo.",
  guide_missing_title: "Corredor sin precio",
  guide_missing_body:
    "Si a un corredor le falta la comisión o el costo del proveedor, se rechazan todas sus entradas y salidas.",

  // Alcance
  scope_label: "¿De quién quieres ver los precios?",
  scope_placeholder: "Buscar organización por nombre, correo o ID…",
  scope_loading: "Cargando organizaciones…",
  scope_empty: "No se encontraron organizaciones.",
  scope_searching: "Buscando organizaciones…",
  scope_search_error: "No pudimos completar la búsqueda; se muestran las organizaciones ya cargadas.",
  scope_catalog_error:
    "No pudimos cargar el catálogo de organizaciones; algunas reglas pueden mostrar el ID en lugar del nombre.",
  scope_catalog_truncated: "Hay más organizaciones de las listadas; escribe para buscarlas todas.",
  scope_global_option: "Precio general (todas las organizaciones)",
  scope_global_hint: "Sin organización elegida: ves y editas el precio general.",
  scope_org_hint: "Ves y editas solo los precios de esta organización.",
  banner_general_title: "Estás en el precio general",
  banner_general_body:
    "Lo que cambies aquí aplica a todas las organizaciones que no tienen precio especial en ese corredor.",
  banner_general_orgs: "Organizaciones con precio especial en algún corredor: {{count}}",
  banner_org_title: "Estás en los precios de {{name}}",
  banner_org_body:
    "Lo que cambies aquí solo afecta a {{name}}. Donde no tiene precio especial, paga el precio general.",
  banner_back_to_general: "Ver precio general",

  // Estados de carga
  truncated_notice:
    "Se cargaron {{loaded}} de {{total}} reglas. Las cifras pueden estar incompletas hasta cargarlas todas.",
  truncated_load_all: "Cargar todas",
  error_load: "No se pudieron cargar las tarifas.",
  error_load_detail: "No se muestra ninguna cifra: nunca se inventan.",
  error_retry: "Reintentar",
  routes_error: "No se pudo cargar el catálogo de corredores.",
  routes_error_detail:
    "Sin él no se pueden calcular precios por corredor. El historial y las reglas siguen disponibles.",

  // Indicadores (también son el filtro)
  kpi_all_label: "Corredores",
  kpi_all_meta: "{{priced}} con precio completo",
  kpi_unpriced_label: "Sin precio completo",
  kpi_unpriced_meta: "Rechazan operaciones",
  kpi_unpriced_ok: "Todos tienen precio",
  kpi_special_label_general: "Con precio especial",
  kpi_special_meta_general: "Alguna organización paga distinto",
  kpi_special_label_org: "Con precio especial",
  kpi_special_meta_org: "Donde esta organización no paga el general",
  kpi_negative_label: "Margen negativo",
  kpi_negative_meta: "Coloca pierde en cada operación",
  kpi_scheduled_label: "Cambios programados",
  kpi_scheduled_meta: "Empiezan más adelante",
  kpi_unavailable: "No disponible",

  // Pestañas
  tab_corridors: "Corredores",
  tab_history: "Historial de cambios",
  tab_commissions: "Reglas de comisión",
  tab_costs: "Reglas de costo",

  // Montos de ejemplo
  examples_label: "Cifras calculadas con una operación de",
  examples_edit_aria: "Cambiar el monto de ejemplo en {{currency}}",
  examples_popover_title: "Monto de ejemplo en {{currency}}",
  examples_popover_hint: "Solo cambia las cifras de esta pantalla, no los precios.",
  examples_reset: "Restablecer",

  // Pestaña de corredores
  corridors_th_corridor: "Corredor",
  corridors_th_commission_general: "Comisión general",
  corridors_th_commission_org: "Comisión de la organización",
  corridors_th_special: "Precio especial",
  corridors_th_cost: "Costo del proveedor",
  corridors_th_client: "Paga el cliente",
  client_pays_taxes: "Incluye {{taxes}}",
  corridors_th_margin: "Margen Coloca",
  corridors_th_status: "Estado",
  corridors_empty_title: "No hay corredores activos",
  corridors_empty_description:
    "Los precios aplican a corredores configurados. Mientras no exista ninguno, no hay nada que tarifar.",
  corridors_filtered_empty_title: "Ningún corredor en este filtro",
  corridors_filtered_empty_description: "Elige otra tarjeta de arriba para ver más corredores.",
  coverage_priced: "Con precio",
  coverage_partial: "Le falta un precio",
  coverage_unpriced: "Sin precio",
  missing_commission: "Falta la comisión",
  missing_cost: "Falta el costo",
  source_special: "Precio especial",
  source_general: "Precio general",
  source_general_baseline: "General: {{price}}",
  source_no_general: "Sin precio general",
  special_count: "{{count}} org.",
  special_none: "Ninguna",
  special_popover_title: "Organizaciones con precio especial",
  special_popover_hint: "Pagan este precio en lugar del general. Elige una para ver o cambiar sus precios.",
  shadowed_warning:
    "Tiene un precio especial que no se aplica aquí: una regla general más específica le gana. Dale un precio especial en este corredor para que aplique.",
  scheduled_chip: "Cambio programado",
  cost_same_for_all: "El costo del proveedor es el mismo para todas las organizaciones.",
  negative_margin_tooltip:
    "Coloca absorbe el costo del proveedor y este supera la comisión: pierde dinero en cada operación de este corredor.",
  why_banner:
    "Un corredor sin comisión o sin costo del proveedor rechaza todas sus entradas y salidas con «no hay configuración de comisión activa».",
  tier_applied: "rango {{tier}}",
  action_edit_commission: "Editar comisión",
  action_give_special: "Dar precio especial",
  action_change_special: "Cambiar precio especial",
  action_back_to_general: "Volver al precio general",
  action_edit_cost: "Editar costo del proveedor",
  action_history: "Historial",
  action_view_rules: "Ver reglas",
  action_more_aria: "Más acciones para {{corridor}}",

  // Modelo económico
  model_pass_through: "Costo cobrado al cliente",
  model_absorbed: "Costo absorbido por Coloca",
  model_pass_through_help:
    "El cliente paga la comisión más el costo del proveedor. Coloca se queda con la comisión.",
  model_absorbed_help:
    "El cliente solo paga la comisión. Coloca paga el costo del proveedor con ella: el margen puede ser negativo.",

  // Enumeraciones
  direction_payin: "Entrada",
  direction_payout: "Salida",
  kind_commission: "Comisión Coloca",
  kind_cost: "Costo del proveedor",
  role_general: "Precio general",
  role_special: "Precio especial",
  role_special_of: "Especial de {{name}}",
  role_cost: "Costo del proveedor",

  // Estado derivado
  status_active: "Vigente",
  status_scheduled: "Programado",
  status_superseded: "Reemplazado",
  status_expired: "Vencido",
  status_disabled: "Desactivado",

  // Chips de alcance
  scope_general: "Todas las organizaciones",
  scope_any_cost_route: "Cualquier ruta de costo",
  scope_any_country: "Cualquier país",
  scope_any_rail: "Cualquier riel",
  scope_any_currency: "Cualquier moneda",
  scope_any_direction: "Entradas y salidas",
  scope_cost_route: "Ruta de costo · {{count}} corredores",
  scope_cost_route_inactive: "Ruta de costo · sin corredor activo",

  // Filtros
  filters_button: "Filtros",
  filters_title: "Filtros",
  filters_apply: "Aplicar",
  filter_corridor_label: "Corredor",
  filter_corridor_all: "Todos los corredores",
  filter_direction_label: "Dirección",
  filter_direction_any: "Entradas y salidas",
  filter_route_label: "Ruta de costo",
  filter_route_all: "Todas las rutas de costo",
  filter_show_superseded: "Mostrar reemplazados y vencidos",
  filter_show_scheduled: "Mostrar programados",
  filter_clear: "Limpiar filtros ({{count}})",

  // Grupos de reglas
  spec_aria: "{{count}} de 6 dimensiones de alcance definidas",
  spec_hint: "Las reglas más específicas ganan sobre las más generales.",
  formula_min: "mín",
  formula_max: "máx",
  formula_ranges: "{{count}} rangos de monto",
  formula_any_currency: "moneda de la operación",
  badge_ranges: "Por rango de monto",
  range_from_to: "{{from}} a menos de {{to}}",
  range_from: "{{from}} en adelante",
  range_base: "precio base",
  group_effective_since: "Vigente desde el {{date}}",
  group_versions: "Cambios: {{count}}",
  group_scheduled_chip: "Cambio programado · {{date}}",
  group_new_version: "Cambiar el precio de esta regla",
  group_duplicate: "Copiar a otro alcance",
  group_expand_aria: "Ver el historial de cambios de esta regla",
  rules_general_only_note:
    "Aquí ves solo las reglas del precio general. Elige una organización arriba para ver sus precios especiales.",

  // Versiones
  stack_th_version: "Versión",
  stack_th_price: "Precio",
  stack_th_effective: "Vigencia",
  stack_th_change: "Cambio",
  stack_th_status: "Estado",
  stack_th_author: "Autor",
  stack_th_reason: "Motivo",
  stack_th_created: "Registrado",
  stack_empty_value: "—",
  stack_actions_aria: "Acciones de la versión {{version}}",
  stack_delete_menu: "Corregir: eliminar este cambio",

  // Periodos y tendencias
  period_range: "{{from}} → {{to}}",
  period_open: "Desde {{from}}",
  period_starts: "Empieza el {{from}}",
  trend_new: "Primer precio",
  trend_up: "Subió",
  trend_down: "Bajó",
  trend_same: "Igual en el ejemplo",
  trend_zero: "Quedó en 0",

  // Estados vacíos
  empty_commissions_title: "No hay reglas de comisión",
  empty_costs_title: "No hay reglas de costo del proveedor",
  empty_description:
    "Mientras un corredor no tenga comisión y costo, todas sus entradas y salidas son rechazadas.",
  empty_cta: "Crear la primera regla",
  empty_filtered_title: "Ninguna regla coincide con estos filtros",
  empty_filtered_description: "Amplía o limpia los filtros para ver las reglas.",
  empty_filtered_cta: "Limpiar filtros",

  // Regla avanzada
  dialog_title_new: "Nueva regla avanzada",
  dialog_title_version: "Cambiar el precio de esta regla",
  dialog_title_duplicate: "Copiar la regla a otro alcance",
  dialog_subtitle:
    "Para reglas que cubren varios corredores. Para un solo corredor, usa los botones de la pestaña Corredores.",
  dialog_section_kind: "1 · ¿Qué estás tarifando?",
  dialog_section_scope: "2 · ¿Dónde aplica?",
  dialog_section_price: "3 · Precio",
  dialog_kind_commission_description: "Lo que le cobramos a la organización. Es ingreso.",
  dialog_kind_cost_description: "Lo que el proveedor de pagos le cobra a Coloca. Es costo.",
  dialog_kind_locked: "fijo para esta regla",
  dialog_scope_locked: "alcance fijo: solo cambian el precio y la vigencia",
  dialog_corridor_label: "Corredor",
  dialog_corridor_placeholder: "Selecciona un corredor…",
  dialog_corridor_helper:
    "Con una sola selección se completan país, moneda, riel y dirección. Marca «cualquiera» para ampliar la regla.",
  dialog_any_country: "Cualquier país",
  dialog_any_rail: "Cualquier riel",
  dialog_any_currency: "Cualquier moneda",
  dialog_any_direction: "Entradas y salidas",
  dialog_who_label: "Para quién",
  dialog_who_general: "Precio general: todas las organizaciones sin precio especial",
  dialog_who_special: "Precio especial: solo {{name}}",
  dialog_cost_general_only:
    "El costo del proveedor es igual para todas las organizaciones. Para crearlo, vuelve al precio general.",
  dialog_route_label: "Ruta de costo",
  dialog_route_any: "Cualquier ruta de costo",
  dialog_route_pick_corridor: "Primero selecciona un corredor",
  dialog_route_helper: "Se deriva del corredor elegido y se envía con la regla.",
  dialog_sentence: "Aplica a {{direction}} en {{country}} por {{rail}} en {{currency}}, para {{who}}.",
  dialog_general_coverage: "Esta regla general cubre {{count}} corredores activos.",
  sentence_direction_both: "entradas y salidas",
  sentence_any_country: "cualquier país",
  sentence_any_rail: "cualquier riel",
  sentence_any_currency: "cualquier moneda",
  sentence_who_general: "todas las organizaciones sin precio especial",
  sentence_who_any_route: "cualquier ruta de costo",
  sentence_who_route: "esta ruta de costo",
  warn_shadow:
    "Ya existe una regla más específica que cubre {{who}} en parte de este alcance. Esta regla no aplicará donde esa coincida.",
  warn_shadow_who_org: "{{name}}",
  warn_shadow_who_route: "una ruta de costo específica",
  warn_collision:
    "Ya existe una versión de esta regla que empieza exactamente en esa fecha y hora. Elige otra hora.",

  // Precio
  price_percentage_label: "Porcentaje",
  price_percentage_helper: "De 0 a 100, hasta 4 decimales. Se cobra sobre el monto de la operación.",
  price_fixed_label: "Monto fijo",
  price_fixed_helper: "Se suma en cada operación.",
  price_min_label: "Comisión mínima",
  price_min_helper: "Piso de la comisión, no del monto.",
  price_max_label: "Comisión máxima",
  price_max_helper: "Techo de la comisión. Vacío = sin límite.",
  price_max_placeholder: "Sin límite",
  price_structure_label: "Tipo de precio",
  price_single_label: "Precio único",
  price_single_hint: "El mismo porcentaje y fijo para cualquier monto.",
  price_ranges_label: "Precio por rango de monto",
  price_ranges_hint: "Cambia según el monto de cada operación (no por volumen).",
  price_base_title: "Precio base",
  currency_operation: "moneda de la op.",

  // Rangos
  tiers_legend: "Rangos por monto de cada operación",
  tiers_th_from: "Desde",
  tiers_th_to: "Hasta (sin incluir)",
  tiers_th_fixed: "Fijo",
  tiers_th_percentage: "Porcentaje",
  tiers_and_above: "en adelante",
  tiers_base_row: "Menos de {{amount}}: usa el precio base de arriba",
  tiers_add: "Agregar rango",
  tiers_remove_aria: "Quitar rango",
  tiers_help:
    "Se mira el monto bruto de cada operación por separado: no es el volumen acumulado del mes. El porcentaje del rango se cobra sobre todo el monto, no por partes, y la comisión mínima y máxima aplican en todos los rangos.",
  tiers_example: "Una operación de {{amount}} cae en «{{range}}» y paga {{fee}} de comisión.",
  tiers_example_label: "Probar con",
  tiers_ruler_aria: "Rangos de monto y el precio de cada uno",

  // Vigencia
  eff_now_label: "Vigente de inmediato",
  eff_date_label: "Fecha de inicio",
  eff_time_label: "Hora",
  eff_resolved: "Empieza el {{datetime}} ({{offset}})",
  eff_pick: "Elige fecha y hora",
  eff_time_note: "La hora importa: dos versiones de la misma regla no pueden empezar en el mismo instante.",
  valid_until_label: "Válida hasta",
  valid_until_helper: "Vacío = sin fecha de fin.",
  reason_label: "Motivo del cambio",
  reason_helper: "Queda en el historial y en la alerta de Discord.",
  reason_placeholder: "Ej.: acuerdo comercial firmado el 8 de octubre",
  version_notice:
    "Será la versión {{next}} de esta regla. La versión {{previous}} queda en el historial y deja de aplicar cuando esta empiece.",

  // Vista previa
  preview_title: "Vista previa",
  preview_amount_label: "Monto de la operación",
  preview_gross: "Bruto",
  preview_commission: "Comisión Coloca",
  preview_cost: "Costo del proveedor",
  preview_client: "Total que paga el cliente",
  preview_net: "Neto al beneficiario",
  preview_margin: "Margen Coloca",
  preview_badge_tier: "Aplica el rango {{tier}}",
  preview_badge_min: "Subió al mínimo de {{amount}}",
  preview_badge_max: "Bajó al máximo de {{amount}}",
  preview_missing_cost: "Este corredor todavía no tiene costo del proveedor: se muestra «—», nunca 0.",
  preview_missing_commission: "Este corredor todavía no tiene comisión: se muestra «—», nunca 0.",
  preview_pick_corridor: "Selecciona un corredor para estimar la otra parte.",
  preview_breakeven:
    "Las operaciones por debajo de {{amount}} serán rechazadas: la comisión no dejaría nada para el beneficiario.",
  preview_breakeven_band:
    "Algunos montos intermedios serán rechazados: un rango sube la comisión por encima de lo que deja el monto. Revisa los rangos antes de guardar.",
  preview_breakeven_all_refused:
    "Con este precio el corredor rechazaría todas las operaciones: ningún monto deja algo para el beneficiario.",
  preview_negative_margin:
    "Coloca absorbe el costo y este supera la comisión: pierde {{amount}} en cada operación de este monto.",
  preview_disclaimer:
    "Estimación con las mismas reglas del motor de pagos. La comisión definitiva se calcula al crear la operación.",
  preview_toggle_aria: "Ver el desglose completo",

  // Editar precio de un corredor
  edit_title_general: "Editar la comisión general",
  edit_title_special: "Precio especial de {{name}}",
  edit_title_cost: "Editar el costo del proveedor",
  edit_applies_general: "Aplica a todas las organizaciones sin precio especial",
  edit_applies_special: "Aplica solo a {{name}}",
  edit_applies_cost: "Lo que el proveedor le cobra a Coloca en este corredor",
  edit_target_label: "¿Qué quieres cambiar?",
  edit_target_broad: "La regla que cubre {{count}} corredores",
  edit_target_broad_hint: "Cambia el precio en todos: {{corridors}}",
  edit_target_corridor: "Solo este corredor",
  edit_target_corridor_hint: "Este corredor tendrá su propio precio; los demás no cambian.",
  edit_compare_title: "Así queda",
  edit_compare_amount: "Operación de {{amount}}",
  edit_compare_today: "Hoy",
  edit_compare_new: "Con el cambio",
  edit_compare_none: "Sin precio",
  edit_compare_client: "Paga el cliente",
  edit_compare_margin: "Margen Coloca",
  edit_also_title: "Aplicar este precio especial también en",
  edit_also_hint: "Solo corredores en {{currency}}. Se guarda uno por corredor.",
  edit_special_broad_note:
    "{{name}} ya tiene un precio especial más amplio que cubre este corredor. Este corredor tendrá el suyo propio.",
  edit_special_no_general:
    "Este corredor no tiene precio general: hoy solo opera para organizaciones con precio especial.",
  edit_shadowed_note:
    "Su precio especial actual no se aplica aquí porque una regla general más específica le gana; este sí aplicará.",
  edit_next: "Revisar el cambio",
  edit_back: "Atrás",
  edit_save: "Guardar precio",

  // Revisión de un cambio general
  review_title: "Revisa antes de guardar",
  review_intro_general: "Vas a cambiar la comisión general en {{count}} corredores:",
  review_intro_cost: "Vas a cambiar el costo del proveedor en {{count}} corredores:",
  review_th_corridor: "Corredor",
  review_th_before: "Hoy",
  review_th_after: "Con el cambio",
  review_orgs_kept: "Estas organizaciones tienen precio especial aquí y no cambian ({{count}}):",
  review_orgs_none: "Ninguna organización tiene precio especial aquí: todas pasan a pagar el precio nuevo.",
  review_zero_warning:
    "La comisión nueva es 0: ninguna organización sin precio especial pagará comisión en estos corredores.",
  review_drop_warning: "La comisión baja más de la mitad en la operación de ejemplo.",
  review_ack: "Entiendo que esto cambia el precio de todas las organizaciones sin precio especial",
  review_ack_cost: "Entiendo que esto cambia el costo del proveedor en estos corredores",

  // Guardado en varios corredores
  save_partial: "Se guardó en {{ok}} de {{total}} corredores. Reintenta los que faltan.",
  save_retry: "Reintentar los que faltan",
  save_row_ok: "Guardado",
  save_row_failed: "No se guardó",
  save_row_pending: "Pendiente",

  // Volver al precio general
  remove_title: "¿Volver al precio general?",
  remove_description: "{{name}} deja de tener precio especial en {{corridor}}.",
  remove_after_title: "Después pagará",
  remove_after_general: "{{price}} (precio general)",
  remove_after_other_special: "{{price}} (otro precio especial más amplio)",
  remove_after_none:
    "Nada: este corredor no tiene precio general, así que rechazará las operaciones de {{name}}.",
  remove_broad_note: "Este precio especial cubre {{count}} corredores y todos vuelven al general:",
  remove_versions_title: "Se eliminan estas versiones",
  remove_confirm: "Volver al precio general",
  remove_progress: "Eliminando {{done}} de {{total}}…",
  remove_partial:
    "Se eliminaron {{done}} de {{total}} versiones y el precio vigente todavía no cambió. Reintenta para terminar.",

  // Historial
  history_drawer_title: "Historial · {{corridor}}",
  history_drawer_desc_general: "Cambios del precio general y del costo del proveedor en este corredor.",
  history_drawer_desc_org:
    "Cambios del precio especial de {{name}}, del precio general y del costo del proveedor en este corredor.",
  history_empty: "Todavía no hay cambios.",
  history_deleted_note:
    "Los cambios eliminados no aparecen aquí porque la API no los devuelve; sí quedaron en Discord.",
  history_recorded: "Registrado el {{date}} por {{author}}",
  history_reason: "Motivo: {{reason}}",
  history_no_reason: "Sin motivo",
  history_not_applying: "Regla más amplia: hoy la reemplaza otra más específica.",
  history_unknown_author: "autor desconocido",
  feed_filter_role: "Tipo de precio",
  feed_role_all: "Todos",
  feed_role_general: "Precio general",
  feed_role_special: "Precios especiales",
  feed_role_cost: "Costos del proveedor",
  feed_only_zero: "Solo cambios que quedaron en 0",
  feed_count: "Cambios: {{count}}",
  feed_load_more: "Ver más",
  feed_today: "Hoy",
  feed_yesterday: "Ayer",
  feed_empty_title: "No hay cambios con estos filtros",
  feed_empty_description: "Cambia los filtros para ver más.",

  // Explicación de cada pestaña
  tab_intro_corridors:
    "Cada fila es un corredor: un país, un riel y una dirección. Ves cuánto se cobra hoy en una operación de ejemplo, quién paga distinto, y desde aquí cambias el precio de ese corredor.",
  tab_intro_history:
    "Todos los cambios de precio, del más reciente al más antiguo: de cuánto a cuánto cambió, quién lo hizo, por qué y desde cuándo aplica.",
  tab_intro_commissions:
    "Las comisiones tal como las guarda el sistema. Una regla puede cubrir varios corredores y la más específica gana. Úsalas para cambios que abarcan varios corredores a la vez.",
  tab_intro_costs:
    "Lo que cada proveedor le cobra a Coloca, como reglas. Es igual para todas las organizaciones y define el margen de cada corredor.",

  // Regla avanzada (página)
  rule_page_subtitle:
    "Para un precio que cubre varios corredores a la vez. Para un solo corredor, usa «Editar» en la pestaña Corredores.",
  rule_back: "Volver a tarifas",
  rule_source_missing: "No encontramos la regla de origen: puede que la hayan eliminado.",
  rule_step_kind: "Qué",
  rule_step_where: "Dónde",
  rule_step_price: "Precio",
  rule_step_review: "Revisar",
  rule_kind_title: "¿Qué quieres tarifar?",
  rule_where_title: "¿Dónde aplica?",
  rule_where_hint: "Elige país, riel y dirección. Lo que dejes en «todos» amplía la regla.",
  rule_country_label: "País",
  rule_country_all: "Todos los países",
  rule_rail_label: "Riel",
  rule_rail_all: "Todos los rieles",
  rule_direction_label: "Dirección",
  rule_direction_both: "Entradas y salidas",
  rule_cost_pin: "Solo para la ruta de costo actual",
  rule_cost_pin_hint: "Si estos corredores cambian de proveedor, la regla dejará de aplicar.",
  rule_covers: "Corredores que cubre: {{count}}",
  rule_covers_none: "Ningún corredor activo coincide con esta combinación.",
  rule_applies: "Aplicará",
  rule_overridden: "No aplica: aquí manda una regla más específica",
  rule_validation_no_corridor: "Elige una combinación donde la regla aplique en al menos un corredor.",
  rule_price_title: "¿Cuánto se cobra?",
  rule_when_title: "¿Desde cuándo?",
  rule_when_now: "Desde que la guardes",
  rule_when_from: "Desde el {{date}}",
  rule_review_applies_on: "Así cambia el precio en los corredores donde aplicará ({{count}}):",
  rule_summary_title: "Resumen",
  rule_summary_kind: "Qué",
  rule_summary_who: "Para quién",
  rule_summary_where: "Dónde",
  rule_summary_where_value: "Aplica en {{applies}} de {{total}} corredores",
  rule_summary_price: "Precio",
  rule_summary_when: "Vigencia",
  rule_summary_source: "Parte de la versión {{version}}: {{price}}",
  rule_next: "Siguiente",
  rule_back_step: "Atrás",
  rule_save: "Guardar regla",

  // Envío
  dialog_cancel: "Cancelar",
  dialog_submit: "Guardar regla",
  validation_percentage: "Ingresa un porcentaje entre 0 y 100 con hasta 4 decimales.",
  validation_money: "Ingresa un monto positivo con hasta 8 decimales.",
  validation_corridor_required: "Selecciona un corredor o marca todas las dimensiones como «cualquiera».",
  validation_tier_threshold: "El inicio de cada rango debe ser 0 o más.",
  validation_tier_threshold_unique: "Dos rangos no pueden empezar en el mismo monto.",
  validation_tier_fixed: "El fijo de cada rango debe ser 0 o más.",
  validation_tier_percentage: "El porcentaje de cada rango debe estar entre 0 y 100.",
  validation_valid_until: "«Válida hasta» debe ser posterior al inicio.",
  validation_valid_from_required: "Elige la fecha y la hora de inicio.",
  validation_reason_required: "Escribe el motivo: los cambios al precio general quedan en el historial.",
  validation_ack_required: "Confirma que entiendes a quién afecta el cambio.",

  toast_created: "Regla guardada: versión {{version}}, vigente desde el {{date}}",
  toast_saved_general: "Comisión general actualizada",
  toast_saved_special: "Precio especial guardado para {{name}}",
  toast_saved_cost: "Costo del proveedor actualizado",
  toast_scheduled: "Cambio programado para el {{date}}",
  toast_removed: "{{name}} vuelve al precio general en {{corridor}}",
  error_create: "No se pudo guardar el precio.",
  error_no_write_permission: "Tu cuenta no puede cambiar tarifas.",

  // Corregir: eliminar un cambio
  delete_title: "¿Eliminar este cambio?",
  delete_semantics:
    "Úsalo solo para corregir un error. Para cambiar un precio, guarda uno nuevo: así queda en el historial.",
  delete_after_title: "Después de eliminarlo aplica",
  delete_after_none: "Nada: el corredor rechazará operaciones",
  delete_escalate_commission:
    "Después de eliminarlo, estos corredores quedan sin comisión y rechazan todas sus entradas y salidas ({{count}}):",
  delete_escalate_cost:
    "Después de eliminarlo, estos corredores quedan sin costo del proveedor y rechazan todas sus entradas y salidas ({{count}}):",
  delete_cancel: "Cancelar",
  delete_confirm: "Eliminar cambio",
  toast_deleted: "Cambio v{{version}} eliminado",
  error_delete: "No se pudo eliminar el cambio.",
  error_delete_missing: "Este cambio ya no existe.",
};
